export interface TramitesProps {
  data: any;
}

export const TablaEventosComponent = ({ data }: TramitesProps) => {
  const Folio = (info: any) => {
    if (info.TipoLLamada === 4) {
      return info.CancelaID;
    }
    if (info.TipoLLamada === 3) {
      return info.EndosoID;
    }
    if (info.TipoLLamada === 5) {
      return info.idSiniestro;
    }
  };

  return (
    <div className="overflow-hidden rounded-[32px] border border-slate-100 bg-white shadow-sm">
      {data && data.length > 0 && (
        <table className="w-full text-left">
          <thead>
            <tr className="border-b border-slate-100 bg-slate-50/50">
              <th className="px-8 py-5 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400">
                Folio de Servicio
              </th>
              <th className="px-8 py-5 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400">
                Tipo
              </th>
              <th className="px-8 py-5 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400">
                Folio
              </th>
              <th className="px-8 py-5 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400">
                Fecha y Hora
              </th>
              <th className="px-8 py-5 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400">
                Operador
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
            {data.map((event) => (
              <tr
                key={event.IDLLAMADA}
                className="group transition-colors hover:bg-slate-50/50"
              >
                <td className="px-8 py-6">
                  <span className="font-manrope text-sm font-black text-slate-900">
                    {event.FolioServicio[0]}
                  </span>
                </td>
                <td className="px-8 py-6">{event.descTipoLlamada}</td>
                <td className="px-8 py-6">
                  <span className="font-manrope text-sm font-black text-slate-900">
                    {Folio(event)}
                  </span>
                </td>
                <td className="px-8 py-6">
                  <div className="flex flex-col">
                    <span className="text-sm font-bold text-slate-700">
                      {event.FECHA_TERMINO}
                    </span>
                  </div>
                </td>
                <td className="px-8 py-6">
                  <div className="flex items-center gap-3">
                    <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-50 text-[10px] font-black uppercase text-metric-blue-700">
                      {event.nombreUsuario[0]}
                      {event.appUsuario[0]}
                    </div>
                    <span className="text-sm font-bold text-slate-600">
                      {event.nombreUsuario} {event.appUsuario}{" "}
                      {event.apmUsuario}
                    </span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
  // return (
  //   <div className="block w-full overflow-x-auto">
  //     <table className="w-full border-collapse items-center bg-transparent ">
  //       <thead>
  //         <tr>
  //           <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
  //             Folio de Servicio
  //           </th>
  //           <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
  //             Tipo
  //           </th>
  //           <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
  //             Fecha
  //           </th>
  //           <th className="border-blueGray-100 whitespace-nowrap border border-l-0 border-r-0 border-solid bg-primary px-6 py-3 text-left align-middle text-xs font-semibold uppercase text-white">
  //             Operador
  //           </th>
  //         </tr>
  //       </thead>
  //       <tbody className="dark:divide-gray-199 divide-y divide-gray-200">
  //         {data &&
  //           data.map((d: any) => {
  //             return (
  //               <tr
  //                 key={d.FolioServicio}
  //                 className="border-b-secondary-ultra-light"
  //               >
  //                 <th className="text-blueGray-700 whitespace-nowrap border-l-0 border-r-0 border-t-0 p-2 px-2 text-left align-middle text-xs ">
  //                   <span className="flex flex-col">
  //                     <span>{d.FolioServicio}</span>
  //                   </span>
  //                 </th>
  //                 <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 text-xs">
  //                   <span className="flex flex-col">
  //                     <span>{tipo_llamada(d)}</span>
  //                   </span>
  //                 </td>
  //                 <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 px-6 text-xs">
  //                   <span className="flex flex-col">
  //                     <span>{fecha_actual(d.FECHA_INICIO)}</span>
  //                   </span>
  //                 </td>
  //                 <td className="align-center whitespace-nowrap border-l-0 border-r-0 border-t-0 p-4 px-6 text-xs">
  //                   <span className="flex flex-col">
  //                     <span>
  //                       {d.nombreUsuario} {d.appUsuario} {d.apmUsuario}
  //                     </span>
  //                   </span>
  //                 </td>
  //               </tr>
  //             );
  //           })}
  //       </tbody>
  //     </table>
  //   </div>
  // );
};
